




























































































import { Vue, Component, Watch } from "vue-property-decorator";
import { Popup, Picker, DatetimePicker, Calendar, Field, Tag, Dialog } from "vant";
import productHome from "../modules/productHome.vue";
import { ApplyArea, Cabin, VoyageType, YesOrNo, ZoneType } from "@/model/Base";
import dataShare from "../dataShare";
import * as _ from "lodash";
import billService from "@/service/billService";
import { TradeDetailEntity } from "@/model/Bill";
// import RetainTickets from "./modules/RetainTickets.vue";
import RetainTickets from "./modules/RetainTickets.vue";
@Component({
  components: {
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [DatetimePicker.name]: DatetimePicker,
    [Calendar.name]: Calendar,
    [Field.name]: Field,
    [Tag.name]: Tag,
    // [Dialog.name]: Dialog as any,
    "product-home": productHome,
    ["retain-tickets"]: RetainTickets,
  },
})
export default class Flight extends Vue {
  //data
  arrivePopupVisible = false;
  departPopupVisible = false;
  cabinPopupVisible = false;
  cabins = [
    { text: this.$root.$t("mall_flight_flight_toudengcang") as string, value: Cabin.First },
    { text: this.$root.$t("mall_flight_flight_shangwucang") as string, value: Cabin.Buissenes },
    { text: this.$root.$t("mall_flight_flight_jingjicang") as string, value: Cabin.Economy },
  ];

  VoyageTypes = [
    { text: this.$root.$t("mall_flight_flight_dancheng") as string, value: VoyageType.SingleVoyage, className: "oneWay" },
    { text: this.$root.$t("mall_flight_flight_wangfan") as string, value: VoyageType.RoundVoyage, className: "roundTrip" },
  ];

  citys = [
    { text: this.$root.$t("mall_flight_flight_shanghai") as string, code: "SHA", CountryID: 151 },
    { text: this.$root.$t("mall_flight_flight_beijing") as string, code: "BJS", CountryID: 151 },
    { text: this.$root.$t("mall_flight_flight_guangzhou") as string, code: "CAN", CountryID: 151 },
  ];

  dataShare = dataShare;
  datePickerVisible = false;
  DepartDate = new Date();
  ArriveDate: Date | null = null;

  selectedCabin = this.cabins[0];
  departCity = this.citys[0];
  arriveCity = this.citys[1];
  get ApplyArea() {
    if (this.departCity && this.departCity.CountryID && this.departCity.CountryID != 151) {
      return ApplyArea.Overseas;
    }
    if (this.arriveCity && this.arriveCity.CountryID && this.arriveCity.CountryID != 151) {
      return ApplyArea.Overseas;
    }
    return ApplyArea.Internal;
  }
  query: any = {
    DepartDate: undefined,
    ArriveDate: undefined,
    DepartCity: this.departCity.code,
    ArriveCity: this.arriveCity.code,
    DepartCityName: this.departCity.text,
    ArriveCityName: this.arriveCity.text,
    ApplyArea: this.ApplyArea,
    BookingType: "1529",
    VoyageType: 1161,
    BerthLevel: 1496,
    ServiceType: "FlightService",
    AdultCount: 1,
    ChildCount: 0,
    InfantCount: 0,
    FeatureCodes: "",
    Consumers: "",
  };
  ymdDate = "YYYY-MM-DD";
  mdDate = this.$root.$t("mall_flight_flight_yueri") as string;
  changeCityFlag = false;
  OneSelf = null;

  get City(): any {
    return this.dataShare.City;
  }
  set City(value: any) {
    this.dataShare.City = value;
  }

  mounted() {
    this.City = null;
    this.dataShare.consumers = [];
    this.loadRetainTickets();
  }

  //activated
  activated() {
    // this.Consumers = dataShare.consumers;
    if (this.selectCode && this.City && this.City.value) {
      let City = this.City;
      if (this.selectCode == "DepartCity") {
        this.departCity = this.City;
        this.query.DepartCityName = City.label;
        this.query.DepartCity = City.value;
        this.query.DepartCode = City.ZoneType == ZoneType.Airport ? City.ZoneCode : null;
      } else if (this.selectCode == "ArriveCity") {
        this.arriveCity = this.City;
        this.query.ArriveCityName = City.label;
        this.query.ArriveCity = City.value;
        this.query.ArriveCode = City.ZoneType == ZoneType.Airport ? City.ZoneCode : null;
      }
    }
  }

  //methods
  flightFormatter(day?: any) {
    if (day.type === "start") {
      day.bottomInfo = "去程";
    } else if (day.type === "end") {
      day.bottomInfo = "返程";
    }
    return day;
  }
  showConsumers() {
    let Flag = true;
    if (this.OneSelf == YesOrNo.Yes) {
      let consumers: any = [
        {
          RoleID: this.profile.UserID,
          RoleName: this.profile.UserName,
        },
      ];
      dataShare.consumers = consumers;
      return (Flag = false);
    }
    return Flag;
  }
  OneSelfs(value: any) {
    this.OneSelf = value;
  }
  @Watch("dataShare.consumers")
  handelConsumers(value: any) {
    this.Consumers = dataShare.consumers;
  }
  formatDate(value: Date, format: string = this.$root.$t("mall_flight_flight_yueri") as string) {
    if (!value) {
      return value;
    }
    return (this as any).$moment(value).format(format);
  }

  onCabinSelect(cabin: any) {
    this.cabinPopupVisible = false;
    this.selectedCabin = cabin;
    this.query.BerthLevel = cabin.value;
  }
  changeVoyageType(voyageType: number) {
    this.query.VoyageType = voyageType;
    if (voyageType == VoyageType.RoundVoyage) {
      this.ArriveDate = (this as any).$moment(this.DepartDate).add(1, "days");
    } else {
      this.ArriveDate = null;
    }
  }
  handleSelect(data: Date | Array<Date>) {
    this.datePickerVisible = false;
    if (data instanceof Array && data.length == 2) {
      this.DepartDate = data[0];
      this.ArriveDate = data[1];
    } else if (data instanceof Date) {
      this.DepartDate = data;
    }
  }
  search() {
    if (this.Consumers.length == 0) {
      return this.$root.$toast.fail(this.$root.$t("mall_flight_flight_qingxuanzelvke") as string);
    }
    this.query.DepartDate = this.formatDate(this.DepartDate, this.ymdDate);
    if (this.ArriveDate) {
      this.query.ArriveDate = this.formatDate(this.ArriveDate, this.ymdDate);
    }
    this.query.Consumers = JSON.stringify(this.Consumers.map((o: any) => ({ ConsumerID: o.RoleID, ConsumerName: o.RoleName })));
    if (dataShare.bookingType) {
      this.query.BookingType = dataShare.bookingType;
    }

    this.query.ApplyArea = this.ApplyArea;
    if (this.ApplyArea == 1126) {
      this.query.BerthLevel = "";
    }
    this.$router.push({ path: "flight/list", query: this.query as any });
  }

  selectCode = "";
  selectCity(cityType: string) {
    this.City = null;
    this.selectCode = cityType;
    this.$router.push({
      path: "/selectAirport",
      query: {
        ServiceType: this.query.ServiceType,
        ApplyArea: this.query.ApplyArea + "",
      },
    });
  }
  timeSelect(value: string) {
    if (value == "Arrive" && this.query.VoyageType == 1161) {
      return;
    }
    this.datePickerVisible = true;
  }
  changeCity() {
    this.changeCityFlag = !this.changeCityFlag;
    const newArriveCity = this.query.ArriveCity;
    const newArriveCityName = this.query.ArriveCityName;
    this.query.ArriveCity = this.query.DepartCity;
    this.query.ArriveCityName = this.query.DepartCityName;
    this.query.DepartCity = newArriveCity;
    this.query.DepartCityName = newArriveCityName;
  }

  Consumers = [];
  //选择乘客
  gotoAddPassengers() {
    dataShare.consumers = this.Consumers;
    this.$router.push("addPassengers");
  }
  //取消选择旅客
  closeBar(consumer: object) {
    this.Consumers = _.difference(this.Consumers, [consumer]) as any;
  }

  RetainTickets: TradeDetailEntity[] = [];
  loadRetainTickets() {
    let __self = this;
    let data = {
      Consumers: [],
      ConsumerCityCode: "",
      FinishedCityCode: "",
      BookingUserID: __self.profile.UserID,
    };
    billService.getUserTicketStatus(data).then(json => {
      if (json.isSucc && json.result) {
        __self.RetainTickets = json.result;
      }
    });
  }
}
